import { useLocation } from "react-router-dom";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useMarketWatchStockContext } from "../../../context/market-watch/MarketWatchStockContext";
import Table from "../../../components/table/Table";
import { MarketWatchHeaderName } from "../../../components/tableHeaderNames/HeaderName";
import MarketChart from "../MarketChart";
import {
  buyOrderRatioDesc,
  buyPowerDesc,
  buyValueDesc,
  moneyFlowDesc,
  sellOrderRatioDesc,
  valueChangeDesc,
} from "../../../components/description/data";

const MarketWatchSingleStock = () => {
  const { pathname } = useLocation();
  const { tableData, highlightedCols } = useMarketWatchStockContext();

  const routeConfigs = {
    "/dashboard/market-watch/stocks/money_flow": {
      tableTitle: { title: "ورود پول حقیقی", desc: moneyFlowDesc },
    },
    "/dashboard/market-watch/stocks/buy_pressure": {
      tableTitle: { title: "قدرت خرید حقیقی", desc: buyPowerDesc },
    },
    "/dashboard/market-watch/stocks/buy_value": {
      tableTitle: { title: "خرید درشت حقیقی", desc: buyValueDesc },
    },
    "/dashboard/market-watch/stocks/buy_ratio": {
      tableTitle: { title: "نسبت سفارش‌های خرید", desc: buyOrderRatioDesc },
    },
    "/dashboard/market-watch/stocks/sell_ratio": {
      tableTitle: { title: "نسبت سفارش‌های فروش", desc: sellOrderRatioDesc },
    },
    "/dashboard/market-watch/stocks/value_change": {
      tableTitle: {
        title: "نسبت ارزش معاملات به میانگین ماهانه",
        desc: valueChangeDesc,
      },
    },
  };

  const tableProps = {
    tableData,
    highlightedCols,
    faCols: MarketWatchHeaderName,
    isActions: true,
    height: "88vh",
    Chart: MarketChart,
    ...routeConfigs[pathname],
  };

  return (
    <Grid2 container>
      <Grid2 xs={12}>
        <Table {...tableProps} />
      </Grid2>
    </Grid2>
  );
};

export default MarketWatchSingleStock;
